import { render, staticRenderFns } from "./Simulator_mobile.vue?vue&type=template&id=77d4dddb&scoped=true&"
import script from "./Simulator_mobile.vue?vue&type=script&lang=js&"
export * from "./Simulator_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Simulator_mobile.vue?vue&type=style&index=0&id=77d4dddb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d4dddb",
  null
  
)

export default component.exports